import React from 'react';

import { ReactComponent as PrivacyDarkIcon } from '@assets/svg/privacy-dark.svg';
import { ReactComponent as PrivacyIcon } from '@assets/svg/privacy.svg';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { usePrivacyPolicySetSettingsMutation } from '@services/usePrivacyPolicySetSettingsMutation';

import { selectAppPersistDarkMode } from '@store/useAppStorePersist';
import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const PrivacyPolicyModal = () => {
  const { t } = useTranslation();

  const { setModalClose, setActiveModal } = useModalActions();

  const { mutate: privacyPolicySetSettingsMutate, isLoading: privacyPolicySetSettingsLoading } =
    usePrivacyPolicySetSettingsMutation();

  const handleSaveActivePolicy = () => {
    privacyPolicySetSettingsMutate(
      {
        privacy_data: {
          strictly_necessary: 1,
          functionality: 1,
          tracking_performance: 1,
          targeting: 1,
        },
      },
      {
        onSuccess: () => {
          setModalClose();
        },
      },
    );
  };

  const darkMode = selectAppPersistDarkMode();

  const TitleIcon = darkMode ? PrivacyDarkIcon : PrivacyIcon;

  const showPrivacyPolicySettingsModal = () =>
    setActiveModal({ name: MODAL_NAMES.privacyPolicySettingsModal });

  return (
    <div className={style.modalPrivacyPolicy}>
      <ModalHeader variant={'woClose'} />
      <div className={style.modalBody}>
        <>
          <div className={style.modalBodyTitle}>{t('Your privacy')}</div>
          <TitleIcon className={style.privacyIcon} />
          <div className={style.modalBodyText}>
            {t(
              'By clicking “ACCEPT All”, you agree to cookies for better site navigation, usage analysis, and marketing assistance.',
            )}
          </div>
        </>
      </div>
      <div className={style.modalFooter}>
        <Button
          type="primary"
          text={t('Accept All')}
          disabled={privacyPolicySetSettingsLoading}
          onClick={handleSaveActivePolicy}
        />
        <Button
          type="secondary"
          text={t('Manage Settings')}
          disabled={privacyPolicySetSettingsLoading}
          onClick={showPrivacyPolicySettingsModal}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
